import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIResult } from '../../global/interfaces/api-result';
import { apiResult } from '../../global/operators/api-result';
import { ApplicationFeature } from 'src/app/feature/interfaces/application-feature';

@Injectable({ providedIn: 'root' })
export class ApiFeatureService {
  apiBase: string = '/api/features';

  constructor(private httpClient: HttpClient) {}

  getFeatures(): Observable<ApplicationFeature> {
    return this.httpClient
      .get<APIResult<ApplicationFeature>>(`${this.apiBase}`)
      .pipe(apiResult());
  }
}
